import { render } from "./dashboardClientComponent.vue?vue&type=template&id=27fbaa64&scoped=true"
import script from "./dashboardClientComponent.vue?vue&type=script&lang=js"
export * from "./dashboardClientComponent.vue?vue&type=script&lang=js"

import "./dashboardClientComponent.vue?vue&type=style&index=0&id=27fbaa64&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27fbaa64"]])

export default __exports__